import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <p>© {new Date().getFullYear()} SmileHub | Powered by SmileHub</p>
    </footer>
  );
}
